export enum AccessRole {
  basketAccess = 'asset.basket.access',
  collectionAccess = 'asset.collection.access',
}

export enum AssetAccessRole {
  tabDownload = 'asset.tab.download',
  tabHistory = 'asset.tab.history',
  tabAssetData = 'asset.tab.data',
  tabVersion = 'asset.tab.version',
  tabAspectRatio = 'asset.tab.aspectratios',
  tabUsageRight = 'asset.tab.usagerights',
  tabRelations = 'asset.tab.relations',
  tabTags = 'asset.tab.tags',
  tabProductionDetails = 'asset.tab.productiondetails',
  infoOnly = 'asset.infoOnly',
}
